import React from 'react'
import { Link } from 'react-router-dom'

function Iris() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">Iris</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newiris.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Iris</h1>
           <p className="text-xl md:text-2xl font-thin max-w-sm mx-auto text-gray-500">The visibility and the highlight that your products deserves.</p>
           <p className="text-xl md:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">IRIS is JORDAO's line of showcases for Coffee Shops, Bakeries, Pastry Shops, Chocolates, Sandwiches, Salads, and Hot Food. Its wide, unobstructed display area provides the best visibility and presentation for your products.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
   <div className="flex flex-col gap-3 md:flex-row justify-center items-center">
     <p className="text-xl md:text-2xl opacity-90">Pastry, Cold Dishes, Sandwiches, Salads and Beverages</p>
     <p className="md:text-xl font-thin opacity-70"><span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
   </div>
   <p className="text-xl md:text-2xl opacity-90">Chocolates <span className=' text-blue-400'>+13… +15 °C</span> (3S)</p>
   <p className="text-xl md:text-2xl opacity-90">Hot Food <span className='text-gray-500'>(hot plate)</span><span className='text-red-500'>+65 °C</span> </p>
   <p className="text-xl md:text-2xl opacity-90">Bakery and Pastry<span className='text-gray-500'> dry ambient</span> </p>
</div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl md:text-2xl text-lime-500 text-center mt-3"> R290</p>
         </div>

         {/* banner */}
         <div className="mt-6 max-w-7xl">
    <div className="p-4">
      <img src="/images/irispre.jpg" alt="Banner" className="w-full h-[650px] object-cover" />
      <p className="text-gray-500 text-xl lg:text-3xl text-center   mt-6">Style, technology and design
      to meet the most<br/> modern concepts of food presentation</p>
      <p className="text-gray-700 font-thin  text-xl md:text-2xl text-center mt-4">Flexible and customisable, for dry ambien, heated and refrigerated products, the IRIS showcase range has an answer whatever your business needs.</p>
    </div>
  </div>
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">The visibility you are looking for your products</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>The wide display area, without obstructions, the high brightness LED lighting and the anti-condensation system of the front glass ensure that your products do not go unnoticed by customers.</div>
    <div className='mt-6 text-xl font-thin text-gray-500'>Available with shelf (optional extra) for greater product capacity and visibility.</div>

</div>


                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/iriscase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
     {/* card & description */}
     <div className="flex flex-wrap gap-6 justify-center mt-32">
  {[
    {
      img: "images/iriscard.jpg",
      title:"Quick product restock",
      text: "Ice cream counters with integrated condensing unit (plug-in).",
    },
    {
      img: "images/iriscard1.jpg",
      title:"Easy cleaning and maintenance",
      text: "Double-glazed end side panels and passive anti-condensation system for greater energy savings.",
    },
    {
      img: "images/iriscard2.jpg",
      title:"Well-illuminated products",
      text: "High brightness and low energy consumption LED lighting that enhances the colours and textures of the products.",
    },
    
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        <p className='text-black text-2xl font-thin'>  {item.title} </p>
        <p className=' text-gray-500 mt-4'> {item.text}</p>
      </div>
    </div>
  ))}
</div>
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/iriscase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">More complete and efficient assisted service</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Dry ambeint, heated, refrigerated displays, POS counters, glass towers, counters, rotating arms for automatic payment terminals... a wide range of options and accessories to meet the most unique needs of your business.</div>
</div>
             </div>
    
    
    
          
         </div>
     </div>
    
  
        </div>
      )
    }

export default Iris